import script from "./RowActionsMenu.vue?vue&type=script&setup=true&lang=js"
export * from "./RowActionsMenu.vue?vue&type=script&setup=true&lang=js"

import "./RowActionsMenu.vue?vue&type=style&index=0&id=20808ee8&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-20808ee8"]])

export default __exports__